export default `
<html>
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Privacy Notice for AI-Assisted Exam Audio Recording</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            margin: 0 auto;
        }
        h2 {
            text-align: center;
            font-size: 20px;
            margin-top: 40px;
            margin-bottom: 20px;
        }
        p {
            margin-bottom: 15px;
        }
        a {
            color: #0066cc;
            text-decoration: none;
        }
        a:hover {
            text-decoration: underline;
        }
    </style>
</head>
<body>
    <h2>Privacy Notice for AI-Assisted Exam Audio Recording</h2>

    <p>This product knowledge exam is organized by XIAOMI VIETNAM COMPANY LIMITED. During the exam, questions will be read aloud by AI, and you are required to respond by voice and <strong>interact with the AI</strong>. The AI will recognize and analyze the content of your responses to generate a preliminary exam result.</p>

    <p>To organize and administer the exam, we will process the following information about you: <strong>employee ID, Xiaomi account information, and audio recordings of your responses</strong>. The AI will score you solely based on the content of your responses as captured in the recordings. It will not analyze your emotions, attitude, confidence level, accent, or any other vocal characteristics. The recordings will be used exclusively for speech-to-text conversion, exam scoring, and any necessary manual review, and will not be used for AI model training or any other purpose.</p>

    <p><strong>Data Processing Description:</strong></p>

    <p>During the exam, the system will collect audio recordings of your responses and convert them to text via <strong>servers located in Singapore</strong>. After the exam is completed, the recordings will be stored on servers in Singapore. Before transferring any data to China, the Singapore server will de-identify the data by removing information that can directly identify you as an individual, such as your name. The de-identified data, comprising the Exam Paper ID and the audio recordings, will be transferred to <strong>servers in China</strong> solely for the purpose of automated scoring. Upon completion of the scoring, the Chinese server will return the Exam Paper ID and corresponding scores to the <strong>Singapore server</strong>, which will then match the scoring results to your identity based on the Exam Paper ID.</p>

    <p>Your recordings will be retained for 90 days from the date your exam result is finalized and will be deleted upon expiration of that period. If you request a manual review, the relevant recordings will be retained for an additional 90 days from the date the review process is concluded and will be deleted upon expiration of that period.</p>

    <p>If you have questions about your score, you may request a manual review by selecting the 【Appeal】 button. Authorized personnel of XIAOMI VIETNAM COMPANY LIMITED will review the corresponding recordings and their transcriptions to complete the score review. Your exam result may be used to identify product knowledge training needs and optimize related training arrangements.</p>

    <p><strong>If you do not consent to the recording, you will not be able to take this exam. If you have previously consented but wish to withdraw your authorization for Xiaomi to process your recordings, you may contact us at <a href="https://privacy.mi.com/support">https://privacy.mi.com/support</a>.</strong> If you withdraw consent before completing the exam, you will not be able to continue. To exercise your rights regarding your personal information, including access and deletion, please see <a href="https://privacy.mi.com/all/languages/">https://privacy.mi.com/all/languages/</a>.</p>

    <h2>语音作答知情同意书</h2>

    <p>本次产品知识考试由 XIAOMI VIETNAM COMPANY LIMITED 组织。考试过程中，题目将由AI进行语音播报，您需要通过语音方式作答并<strong>与AI进行交互</strong>。AI将识别并分析您的作答内容，据此生成初步考试成绩。</p>

    <p>为了组织和完成考试，我们会使用您的以下信息：<strong>工号、小米账号信息、作答录音</strong>。AI仅根据录音中所包含的作答内容进行评分，不会分析您的情绪、态度、自信程度、口音或其他声音特征。相关录音仅用于语音转写、考试评分及必要的人工复核，不会用于AI模型训练或任何其他目的。</p>

    <p><strong>数据处理说明：</strong></p>

    <p>在您作答过程中，系统将采集您的作答录音，并通过位于新加坡的服务器将录音转换为文字。考试结束后，相关录音将存储于<strong>新加坡服务器</strong>。在向中国境内传输数据前，新加坡服务器将对相关数据进行去标识化处理，移除您的姓名等可直接识别个人身份的信息。去标识化后的数据，包括考卷ID及作答录音，将传输至<strong>中国服务器</strong>，仅用于自动化评分。评分完成后，中国服务器将考卷ID及对应分数回传至<strong>新加坡服务器</strong>，再由新加坡服务器根据考卷ID将评分结果与您的身份信息进行匹配。</p>

    <p>您的录音将在考试成绩确定之日起保留90日，并在保留期限届满后删除。如您申请人工复核，相关录音将在复核程序结束之日起继续保留90日，并在该期限届满后删除。</p>

    <p>如果您对分数有异议，可通过【申诉】按钮申请人工复核。XIAOMI VIETNAM COMPANY LIMITED 的授权人员将查阅相应的录音和其转写文字，以完成成绩复核。考试结果可能用于识别产品知识培训需求、优化相关培训安排。</p>

    <p><strong>如您不同意录音，将无法参加本次考试。如您已同意录音但需撤回对小米的授权，您可通过 <a href="https://privacy.mi.com/support">https://privacy.mi.com/support</a> 联系我们</strong>；如考试尚未完成，撤回同意后考试将无法继续进行。有关您的个人信息访问、删除等权利，请查看 <a href="https://privacy.mi.com/all/languages/">https://privacy.mi.com/all/languages/</a>。</p>
</body>
</html>
`